import {
    createVNode as _$cv,
    className as _$cn,
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    noop as _$no,
} from 'intact';
import {Icon} from '../icon';
import {Media} from '../media';
import {getRestProps, isEmptyString} from '../utils';
import {makeStyles} from './styles';
import {_$} from '../../i18n';
import {isInvalid, noop} from 'intact-shared';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$blocks = {};
    var __$blocks = {};
    
    const {
        getRootClassNameObj,
        getProgressStyle,
        onClick,
        isMediaType,
        shouldShowDeleteButton,
        onDelete,
        getValue,
        onPreview,
        isError,
        getMediaLoadingText,
        getMediaErrorText,
        getMediaErrorArtworkIconSrc,
        shouldShowMediaStatusLayer,
        shouldRenderMediaErrorArtwork,
        shouldUseMediaErrorArtworkLayout,
        shouldShowVisualMediaProgressText,
        getMediaProgressText,
        getFileBadgeClassName,
        getFileBadgeText,
        hasCustomIcon,
        getIconSource,
        hasBuiltinIcon,
        getBuiltinIconSource,
        getFileName,
        getFileTitleText,
        getNamePrefix,
        hasNameSuffix,
        getNameSuffix,
        shouldShowMiniFileStatusTitle,
        getDisplayDescription,
        getMediaType,
        getFileMediaType,
        getMediaStatus,
        getMediaShowPreview,
        onMediaError,
        getMediaSize,
        getFileMediaSize,
        shouldShowFileMedia,
    } = this.model;
    
    const {
        className, style,
    } = this.get();
    const {k} = this.config;
    const maskBlock = $blocks.mask;
    const isEmptySlot = (value) => {
        if (isInvalid(value) || isEmptyString(value)) return true;
        if (Array.isArray(value)) return value.every(item => isEmptySlot(item));
        if (value && value.type === 1) return isEmptySlot(value.children);
    
        return false;
    };
    const value = getValue();
    const shouldShowFileContent = !isMediaType();
    const descriptionSlot = shouldShowFileContent && $blocks.description ? $blocks.description(noop, value) : undefined;
    const fileMaskSlot = shouldShowFileContent && maskBlock ? maskBlock(noop, value) : undefined;
    const hasDescriptionSlot = !isEmptySlot(descriptionSlot);
    const hasFileMaskSlot = !isEmptySlot(fileMaskSlot);
    const isMini = (this.get('size') || 'default') === 'mini';
    const showDescription = !isMini && (hasDescriptionSlot || !!getDisplayDescription());
    const classNameObj = {
        [`${k}-file-card`]: true,
        [className]: className,
        [makeStyles(k)]: true,
        ...getRootClassNameObj(),
    };
    
    return _$cv('div', {
        'className': _$cn(classNameObj),
        ...getRestProps(this),
        'style': style,
        'ev-click': onClick
    }, [
        (shouldShowDeleteButton()) ?
            _$ce(2, 'div', (
                _$cc(Icon, {
                    'className': _$cn(`${k}-icon-close-bold`),
                    'color': 'inherit'
                })
            ), 2, _$cn(`${k}-file-card-delete`), {
                'title': _$('删除'),
                'ev-click': onDelete
            }) :
            undefined,
        (!shouldShowFileContent) ?
            (
                _$ce(2, 'div', [
                    _$cc(Media, {
                        'className': _$cn(`${k}-file-card-media-view`),
                        'name': getFileName(),
                        'type': getMediaType(),
                        'status': getMediaStatus(),
                        'src': this.get('src'),
                        'poster': this.get('poster'),
                        'size': getMediaSize(),
                        'showPreview': getMediaShowPreview(),
                        'showNameTooltip': this.get('showNameTooltip'),
                        'imageProps': this.get('imageProps'),
                        'videoProps': this.get('videoProps'),
                        'audioProps': this.get('audioProps'),
                        'ev-preview': onPreview,
                        'ev-loadError': onMediaError,
                        '$blocks': function($blocks) {
                            var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                            return (
                                (
                                    (_$blocks['error'] = function($super) {
                                        return (
                                            (shouldRenderMediaErrorArtwork()) ?
                                                _$ce(2, 'div', [
                                                    _$ce(2, 'img', null, 1, _$cn(`${k}-file-card-media-error-artwork-icon`), {
                                                        'src': getMediaErrorArtworkIconSrc(),
                                                        'alt': '',
                                                        'draggable': false
                                                    }),
                                                    _$ce(2, 'span', getMediaErrorText(), 0, _$cn(`${k}-file-card-error-text ${k}-file-card-media-error-artwork-text`))
                                                ], 4, _$cn(`${k}-file-card-media-error-artwork-content`)) :
                                                undefined
                                        );
                                    }),
                                    (__$blocks['error'] = function($super, data) {
                                        var block = $blocks['error'];
                                        var callBlock = function() {
                                            return _$blocks['error'].call($this, $super, data);
                                        };
                                        return block ?
                                            block.call($this, callBlock, data) :
                                            callBlock();
                                    })
                                ),
                                (
                                    (_$blocks['mask'] = function($super, media) {
                                        return maskBlock && maskBlock(noop, media);
                                    }),
                                    (__$blocks['mask'] = function($super, data) {
                                        var block = $blocks['mask'];
                                        var callBlock = function() {
                                            return _$blocks['mask'].call($this, $super, data);
                                        };
                                        return block ?
                                            block.call($this, callBlock, data) :
                                            callBlock();
                                    })
                                ),
                                __$blocks
                            );
                        }.call($this, _$em)
                    }),
                    (shouldShowMediaStatusLayer() && !shouldUseMediaErrorArtworkLayout()) ?
                        _$ce(2, 'div', (
                            _$ce(2, 'span', isError() ? getMediaErrorText() : getMediaLoadingText(), 0, _$cn({
                                [`${k}-file-card-media-loading-text`]: !isError(),
                                [`${k}-file-card-error-text`]: isError(),
                            }))
                        ), 2, _$cn(`${k}-file-card-media-status-layer`)) :
                        undefined,
                    (shouldShowVisualMediaProgressText()) ?
                        _$ce(2, 'div', getMediaProgressText(), 0, _$cn(`${k}-file-card-media-progress-text`)) :
                        undefined
                ], 0, _$cn(`${k}-file-card-media-shell`))
            ) :
            (
                _$ce(2, 'div', [
                    _$ce(2, 'div', [
                        (shouldShowFileMedia()) ?
                            _$cc(Media, {
                                'className': _$cn(`${k}-file-card-file-media-view`),
                                'name': getFileName(),
                                'type': getFileMediaType(),
                                'src': this.get('src'),
                                'poster': this.get('poster'),
                                'size': getFileMediaSize(),
                                'showPreview': this.get('showPreview'),
                                'showNameTooltip': false,
                                'imageProps': this.get('imageProps'),
                                'videoProps': this.get('videoProps'),
                                'audioProps': this.get('audioProps'),
                                'ev-preview': onPreview
                            }) :
                            _$ce(2, 'div', (
                                (hasCustomIcon()) ?
                                    _$ce(2, 'img', null, 1, _$cn(`${k}-file-card-file-icon-img`), {
                                        'src': getIconSource(),
                                        'alt': getFileName()
                                    }) :
                                    $blocks.icon ?
                                        (
                                            (_$blocks['icon'] = function($super) {
                                                return null;
                                            }),
                                            (__$blocks['icon'] = function($super, data) {
                                                var block = $blocks['icon'];
                                                var callBlock = function() {
                                                    return _$blocks['icon'].call($this, $super, data);
                                                };
                                                return block ?
                                                    block.call($this, callBlock, data) :
                                                    callBlock();
                                            }),
                                            __$blocks['icon'](_$no, getValue())
                                        ) :
                                        hasBuiltinIcon() ?
                                            _$ce(2, 'img', null, 1, _$cn(`${k}-file-card-file-icon-img`), {
                                                'src': getBuiltinIconSource(),
                                                'alt': getFileName()
                                            }) :
                                            _$ce(2, 'span', getFileBadgeText(), 0)
                            ), 0, _$cn(`${k}-file-card-file-icon ${k}-file-card-file-icon-${getFileBadgeClassName()}`)),
                        _$ce(2, 'div', [
                            _$ce(2, 'div', (
                                (shouldShowMiniFileStatusTitle()) ?
                                    _$ce(2, 'span', getFileTitleText(), 0, _$cn({
                                        [`${k}-file-card-title-prefix`]: true,
                                        [`${k}-file-card-title-status`]: true,
                                        [`${k}-file-card-title-status-error`]: isError(),
                                    })) :
                                    [
                                        _$ce(2, 'span', getNamePrefix(), 0, _$cn(`${k}-file-card-title-prefix`)),
                                        (hasNameSuffix()) ?
                                            _$ce(2, 'span', getNameSuffix(), 0, _$cn(`${k}-file-card-title-suffix`)) :
                                            undefined
                                    ]
                            ), 0, _$cn(`${k}-file-card-title`), {
                                'title': getFileTitleText()
                            }),
                            (showDescription) ?
                                _$ce(2, 'div', (
                                    (hasDescriptionSlot) ?
                                        descriptionSlot :
                                        _$ce(2, 'span', getDisplayDescription(), 0)
                                ), 0, _$cn(`${k}-file-card-description`)) :
                                undefined
                        ], 0, _$cn(`${k}-file-card-file-content`))
                    ], 4, _$cn(`${k}-file-card-file-main`)),
                    (hasFileMaskSlot) ?
                        _$ce(2, 'div', fileMaskSlot, 0, _$cn(`${k}-file-card-mask ${k}-file-card-file-mask`)) :
                        undefined
                ], 0, _$cn(`${k}-file-card-file-shell`), {
                    'style': getProgressStyle()
                })
            )
    ]);
};